import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7a483fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header nav-undecorated" }
const _hoisted_2 = { class: "border-bottom" }
const _hoisted_3 = { class: "container-fluid mw-xl" }
const _hoisted_4 = { class: "col p-0" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center h-100" }
const _hoisted_6 = { class: "header-logo header-logo-lu flex-grow-1 flex-lg-grow-0" }
const _hoisted_7 = { class: "m-0 p-0" }
const _hoisted_8 = ["href", "title"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "flex-shrink-1 flex-lg-shrink-0 flex-grow-0 d-flex flex-column justify-content-between h-100 mh-120" }
const _hoisted_11 = { class: "h-lg-auto flex-column justify-content-between align-items-end font-size-sm font-size-sm-base flex-grow-0" }
const _hoisted_12 = { class: "nav text-center h-100 h-lg-auto align-items-center d-lg-none flex-nowrap" }
const _hoisted_13 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "d-none d-lg-flex flex-column flex-xl-row w-100 justify-content-end" }
const _hoisted_21 = {
  key: 0,
  class: "nav align-items-center justify-content-end flex-1 mb-3 mb-xl-0"
}
const _hoisted_22 = { class: "nav-item flex-xl-grow-1" }
const _hoisted_23 = { class: "nav align-items-center justify-content-end" }
const _hoisted_24 = { class: "nav-item d-none d-lg-block" }
const _hoisted_25 = { class: "mr-1" }
const _hoisted_26 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_27 = { class: "mr-1" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = {
  class: "nav-link px-0 ml-4",
  href: "#"
}
const _hoisted_30 = { class: "mr-1" }
const _hoisted_31 = {
  key: 2,
  class: "nav-item d-none d-lg-block d-xl-none border-left ml-3 pl-3"
}
const _hoisted_32 = ["aria-label"]
const _hoisted_33 = { class: "header-search-form collapse-lg pb-2 px-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"none"} }, [
  /*#__PURE__*/_createElementVNode("div", { id: "__ba_launchpad" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LuNavbar = _resolveComponent("LuNavbar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_LuHeaderAuthButtons = _resolveComponent("LuHeaderAuthButtons")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_LuTopMenu = _resolveComponent("LuTopMenu")!
  const _component_LuNavMobile = _resolveComponent("LuNavMobile")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (_ctx.navbarmenu)
      ? (_openBlock(), _createBlock(_component_LuNavbar, {
          key: 0,
          menu: _ctx.navbarmenu
        }, null, 8, ["menu"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["row m-0", [_ctx.compact ? 'py-2' : 'py-3 py-lg-5']])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h1", _hoisted_7, [
                  _createElementVNode("a", {
                    href: _ctx.logoUrl,
                    title: _ctx.logoTitle
                  }, [
                    (_ctx.logoSrc)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.logoSrc,
                          alt: _ctx.logoTitle,
                          class: "mw-100",
                          style: {"height":"7rem"}
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("nav", _hoisted_12, [
                    (_ctx.hasSearch)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("a", {
                            class: "ml-2 p-1 d-block nav-undecorated",
                            href: "#",
                            "data-toggle": "collapse",
                            "aria-controls": "header-search-form",
                            "aria-expanded": "false",
                            "aria-label": _ctx.$t('header.show-hide-search'),
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)), ["prevent"]))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: 'search' }),
                            _hoisted_15,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("shared.search")), 1)
                          ], 8, _hoisted_14)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showMobileMenu)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("a", {
                            class: "ml-2 p-1 d-block nav-undecorated",
                            href: "#",
                            "aria-controls": "nav-mobile",
                            "aria-expanded": "false",
                            "aria-label": _ctx.$t('header.show-menu'),
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showNavMobile && _ctx.showNavMobile(...args)), ["prevent"]))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: 'bars' }),
                            _hoisted_18,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("header.menu")), 1)
                          ], 8, _hoisted_17)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (_ctx.showLogin)
                            ? (_openBlock(), _createBlock(_component_LuHeaderAuthButtons, { key: 0 }))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (_ctx.hasSearch)
                      ? (_openBlock(), _createElementBlock("nav", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            (_ctx.hasSearch)
                              ? (_openBlock(), _createBlock(_component_Search, {
                                  key: 0,
                                  value: _ctx.searchValue,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchValue) = $event)),
                                  onSubmit: _ctx.search,
                                  placeholder: _ctx.searchPlaceholder
                                }, null, 8, ["value", "onSubmit", "placeholder"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("nav", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("a", {
                          class: "nav-link px-0 ml-4",
                          href: "#",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchLocale && _ctx.switchLocale(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("span", _hoisted_25, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "fa-lg",
                              icon: "globe"
                            })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("header.select-locale.language")), 1)
                        ])
                      ]),
                      (_ctx.hasListen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("a", {
                              class: "nav-link px-0 ml-4",
                              href: "#",
                              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.listen && _ctx.listen(...args)), ["prevent"]))
                            }, [
                              _createElementVNode("span", _hoisted_27, [
                                _createVNode(_component_font_awesome_icon, {
                                  class: "fa-solid",
                                  icon: "volume"
                                })
                              ]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("header.listen")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showLogin)
                        ? (_openBlock(), _createBlock(_component_LuHeaderAuthButtons, { key: 1 }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("a", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, [
                            (
                                _ctx.environment === 'Development' ||
                                _ctx.environment === 'Test'
                              )
                              ? (_openBlock(), _createBlock(_component_Badge, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.environment), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (_ctx.showMobileMenu)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("a", {
                              class: "nav-link",
                              href: "#",
                              "aria-controls": "nav-mobile",
                              "aria-expanded": "false",
                              "aria-label": _ctx.$t('header.show-menu'),
                              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showNavMobile && _ctx.showNavMobile(...args)), ["prevent"]))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: 'bars' }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("header.menu")), 1)
                            ], 8, _hoisted_32)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.topmenu)
                  ? (_openBlock(), _createBlock(_component_LuTopMenu, {
                      key: 0,
                      menu: _ctx.topmenu
                    }, null, 8, ["menu"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 2)
      ]),
      _createVNode(_Transition, { name: "slide" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_33, [
            (_ctx.hasSearch)
              ? (_openBlock(), _createBlock(_component_Search, {
                  key: 0,
                  value: _ctx.searchValue,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchValue) = $event)),
                  onSubmit: _ctx.search,
                  placeholder: _ctx.searchPlaceholder,
                  ref: "mobileSearchInput"
                }, null, 8, ["value", "onSubmit", "placeholder"]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !_ctx.searchCollapsed]
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_LuNavMobile, {
      menu: _ctx.mobilemenu,
      ref: "navMobile"
    }, null, 8, ["menu"]),
    _hoisted_34
  ]))
}